import gql from 'graphql-tag';

export default gql`
  query validatePassword($input: PasswordInput!) {
    validatePassword(input: $input)
  }
`;
